import { render } from "./PropertyCard.vue?vue&type=template&id=480ccb1b"
import script from "./PropertyCard.vue?vue&type=script&lang=js"
export * from "./PropertyCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__